export default function filter(nodes, predicate, level = 0) {
  return nodes
    .filter((node, i) => predicate(node, i, level))
    .map((node) => node.set('children', filter(node.get('children'), predicate, level + 1)))
}
